import { Component, Watch } from "@/decorators";
import RelatorioService from "@/services/relatorioService";
import Delay from "@/utils/common/delay";
import Vue from "vue";

import "../crud/crud.scss";
import "./list.scss";

@Component
export default class RelatorioListComponent extends Vue {
    private service: RelatorioService = new RelatorioService();
    private relatoriosPermitidos: string[] = [];
    private filtro: string = "";

    constructor() {
        super();
    }

    private normalizarTexto(texto: string): string {
        return texto
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase();
    }

    @Watch("filtro")
    private async onFiltroChange() {
        await this.$nextTick();
        this.aplicarFiltroTexto();
        this.ajustarTodasCategorias();
    }

    private aplicarFiltroTexto() {
        const termo = this.normalizarTexto(this.filtro.trim());

        document.querySelectorAll(".rel").forEach(rel => {
            const texto = this.normalizarTexto(rel.textContent || "");
            rel.classList.toggle("filtro-oculto", !!termo && !texto.includes(termo));
        });
    }

    private async load() {
        this.relatoriosPermitidos = await this.service
            .getRelatoriosPermitidos()
            .then(r => r.json() as Promise<string[]>)
            .withLoading();

        this.ajustarCategoriasRelatorios();
    }

    private async ajustarCategoriasRelatorios() {
        await Delay(500);

        this.ajustarTodasCategorias();
    }

    private ajustarTodasCategorias() {
        this.ajustarCategoriaRelatorio("#catComissao");
        this.ajustarCategoriaRelatorio("#catOrcamento");
        this.ajustarCategoriaRelatorio("#catFaturamento");
        this.ajustarCategoriaRelatorio("#catVendas");
        this.ajustarCategoriaRelatorio("#catNotas");
        this.ajustarCategoriaRelatorio("#catProdutos");
        this.ajustarCategoriaRelatorio("#catFinanceiro");
        this.ajustarCategoriaRelatorio("#catEstoque");
        this.ajustarCategoriaRelatorio("#catOutros");
    }

    private async ajustarCategoriaRelatorio(id: string) {
        const categoria = document.querySelector(id);
        if (categoria) {
            const relatorios = categoria.querySelectorAll(".rel");
            let temElementoVisivel = false;

            relatorios.forEach(rel => {
                if (getComputedStyle(<Element>rel).display !== "none") {
                    temElementoVisivel = true;
                }
            });

            if (temElementoVisivel) {
                categoria.classList.remove("hide");
            } else {
                categoria.classList.add("hide");
            }
        }
    }

    private permiteExibir(nome: string) {
        if (!this.relatoriosPermitidos || this.relatoriosPermitidos.length == 0) {
            return false;
        }

        return this.relatoriosPermitidos.indexOf(nome) > -1;
    }

    private async mounted() {
        await this.load();
    }
}
